/* Tienda Crema — theme. Portado de la demo, con carrito real de Shopify. */
(function () {
  document.documentElement.classList.add('js');
  window.addEventListener('load', function () { document.body.classList.add('loaded'); });
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function money(cents) { return 'S/ ' + (cents / 100).toFixed(2); }

  /* ---------- toast ---------- */
  var toast = document.createElement('div');
  toast.className = 'toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite');
  document.body.appendChild(toast);
  var tt;
  function showToast(m) { toast.textContent = m; toast.classList.add('show'); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('show'); }, 1900); }

  /* ---------- cart drawer (Shopify) ---------- */
  var ov = document.createElement('div'); ov.className = 'cart-ov';
  var dr = document.createElement('aside');
  dr.className = 'cart'; dr.setAttribute('role', 'dialog'); dr.setAttribute('aria-modal', 'true'); dr.setAttribute('aria-label', 'Tu carrito'); dr.hidden = true;
  dr.innerHTML =
    '<div class="ch"><h2>Tu carrito (<span data-n>0</span>)</h2><button class="x" data-close aria-label="Cerrar carrito">✕</button></div>' +
    '<div class="items" data-items></div>' +
    '<div class="rel" data-rel hidden><p class="rel-t">Completa tu pedido</p><div class="rel-row" data-rel-row></div></div>' +
    '<div class="foot">' +
    '<div class="cdoc-mini" data-doc>' +
      '<div class="tabs" role="radiogroup" aria-label="Tipo de comprobante">' +
        '<label><input type="radio" name="dw-comprobante" value="Boleta" checked><span>Boleta</span></label>' +
        '<label><input type="radio" name="dw-comprobante" value="Factura"><span>Factura</span></label>' +
      '</div>' +
      '<select data-doc-tipo aria-label="Tipo de documento"><option value="DNI">DNI</option><option value="CE">Carné de extranjería</option><option value="PASAPORTE">Pasaporte</option></select>' +
      '<input type="text" data-doc-num inputmode="numeric" autocomplete="off" maxlength="12" placeholder="DNI (8 dígitos)" aria-label="Número de documento">' +
      '<input type="text" data-doc-razon placeholder="Razón social" aria-label="Razón social" hidden>' +
      '<p class="doc-err" data-doc-err hidden>La factura necesita un RUC de 11 dígitos que empiece en 10 o 20.</p>' +
    '</div>' +
    '<div class="sub"><b>Subtotal</b><span class="v" data-sub>S/ 0.00</span></div>' +
    '<p class="fine">Envío e impuestos calculados en el checkout.</p>' +
    '<a class="btn btn-primary" data-checkout href="' + ROOT + 'checkout">Ir a pagar</a></div>';
  document.body.appendChild(ov); document.body.appendChild(dr);

  var lastFocus = null;
  function openCart() { lastFocus = document.activeElement; dr.hidden = false; requestAnimationFrame(function () { ov.classList.add('show'); dr.classList.add('show'); }); document.body.style.overflow = 'hidden'; dr.querySelector('[data-close]').focus(); }
  function closeCart() { ov.classList.remove('show'); dr.classList.remove('show'); document.body.style.overflow = ''; setTimeout(function () { dr.hidden = true; }, 350); if (lastFocus) lastFocus.focus(); }
  ov.addEventListener('click', closeCart);
  dr.querySelector('[data-close]').addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dr.hidden) closeCart(); });

  function renderCart(cart) {
    var n = cart.item_count;
    dr.querySelector('[data-n]').textContent = n;
    dr.querySelector('[data-sub]').textContent = money(cart.total_price);
    document.querySelectorAll('[data-cartcount]').forEach(function (c) { c.textContent = n; c.classList.add('pop'); setTimeout(function () { c.classList.remove('pop'); }, 260); });
    var box = dr.querySelector('[data-items]');
    if (!cart.items.length) {
      box.innerHTML = '<div class="empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 4h2l2.2 11.2a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.2L20.5 8H6"/><circle cx="9.5" cy="20" r="1.4"/><circle cx="16.5" cy="20" r="1.4"/></svg><p>Tu carrito está vacío.</p></div>';
      return;
    }
    box.innerHTML = cart.items.map(function (i) {
      var props = '';
      if (i.properties) { for (var k in i.properties) { if (k[0] !== '_' && i.properties[k]) props += '<span class="pmeta">' + k + ': ' + i.properties[k] + '</span>'; } }
      return '<div class="li"><img src="' + (i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : '') + '" alt="" loading="lazy"><div class="d">' +
        '<b>' + i.product_title + '</b><p class="meta">' + (i.variant_title || '') + '</p>' +
        (props ? '<div class="pmetas">' + props + '</div>' : '') +
        '<div class="lrow"><div class="lqty">' +
          '<button type="button" data-qd="' + i.key + '" data-q="' + (i.quantity - 1) + '" aria-label="Quitar una unidad">−</button>' +
          '<span>' + i.quantity + '</span>' +
          '<button type="button" data-qd="' + i.key + '" data-q="' + (i.quantity + 1) + '" aria-label="Agregar una unidad">+</button>' +
        '</div><span class="pr">' + money(i.final_line_price) + '</span></div>' +
        '<button class="rm" data-rm="' + i.key + '" aria-label="Eliminar ' + i.product_title.replace(/"/g, '') + ' del carrito">Eliminar</button></div></div>';
    }).join('');
    box.querySelectorAll('[data-rm]').forEach(function (b) {
      b.addEventListener('click', function () { b.disabled = true; changeQty(b.dataset.rm, 0); });
    });
    box.querySelectorAll('[data-qd]').forEach(function (b) {
      b.addEventListener('click', function () { changeQty(b.dataset.qd, parseInt(b.dataset.q, 10)); });
    });
    renderRelated(cart);
    syncDocFromCart(cart);
  }

  /* ---------- recomendados en el drawer ---------- */
  var relBox = dr.querySelector('[data-rel]');
  var relRow = dr.querySelector('[data-rel-row]');
  var relFor = null;
  function renderRelated(cart) {
    if (!cart.items.length) { relBox.hidden = true; relFor = null; return; }
    var pid = cart.items[0].product_id;
    if (relFor === pid) return; // ya cargados para este producto
    relFor = pid;
    var enCarrito = {}; cart.items.forEach(function (i) { enCarrito[i.product_id] = 1; });
    fetch(ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=6')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d.products || []).filter(function (p) { return p.available && !enCarrito[p.id]; }).slice(0, 3);
        if (!prods.length) { relBox.hidden = true; return; }
        relRow.innerHTML = prods.map(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (!v) return '';
          return '<div class="rp"><a href="' + p.url + '"><img src="' + (p.featured_image || '') + '" alt="" loading="lazy"><span class="t">' + p.title + '</span></a>' +
            '<div class="b"><span class="p">' + money(v.price) + '</span><button type="button" data-rel-add="' + v.id + '" data-rel-name="' + p.title.replace(/"/g, '') + '">Agregar</button></div></div>';
        }).join('');
        relBox.hidden = relRow.innerHTML === '';
        relRow.querySelectorAll('[data-rel-add]').forEach(function (b) {
          b.addEventListener('click', function () { b.disabled = true; addToCart({ items: [{ id: parseInt(b.dataset.relAdd, 10), quantity: 1 }] }, b.dataset.relName).then(function () { relFor = null; }); });
        });
      })
      .catch(function () { relBox.hidden = true; });
  }

  /* ---------- documento (DNI/RUC) en el drawer ---------- */
  var docNum = dr.querySelector('[data-doc-num]');
  var docRazon = dr.querySelector('[data-doc-razon]');
  var docErr = dr.querySelector('[data-doc-err]');
  var docTipoSel = dr.querySelector('[data-doc-tipo]');
  var docSynced = false;
  var DW_REGLAS = {
    DNI: { re: /^\d{8}$/, ph: 'DNI (8 dígitos)', num: true, max: 8 },
    CE: { re: /^[A-Z0-9]{6,12}$/, ph: 'Carné de extranjería', num: false, max: 12 },
    PASAPORTE: { re: /^[A-Z0-9]{5,12}$/, ph: 'Pasaporte', num: false, max: 12 },
    RUC: { re: /^(10|20)\d{9}$/, ph: 'RUC (11 dígitos)', num: true, max: 11 }
  };
  function dwEsFactura() { return dr.querySelector('input[name="dw-comprobante"]:checked').value === 'Factura'; }
  function dwRegla() { return dwEsFactura() ? DW_REGLAS.RUC : (DW_REGLAS[docTipoSel.value] || DW_REGLAS.DNI); }
  function dwValido() {
    var d = docNum.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    return dwRegla().re.test(d);
  }
  function dwModo() {
    var f = dwEsFactura();
    var r = dwRegla();
    docNum.placeholder = r.ph;
    docNum.setAttribute('maxlength', r.max);
    docNum.setAttribute('inputmode', r.num ? 'numeric' : 'text');
    docTipoSel.hidden = f;
    docRazon.hidden = !f;
    docErr.hidden = dwValido() || docNum.value.trim() === '';
  }
  function syncDocFromCart(cart) {
    if (docSynced) return; docSynced = true;
    var a = cart.attributes || {};
    if (a.comprobante === 'Factura') dr.querySelectorAll('input[name="dw-comprobante"]')[1].checked = true;
    if (a.tipo_documento && DW_REGLAS[a.tipo_documento]) docTipoSel.value = a.tipo_documento;
    if (a.documento) docNum.value = a.documento;
    if (a.razon_social) docRazon.value = a.razon_social;
    dwModo();
  }
  var docTimer;
  function guardarDoc() {
    return fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { comprobante: dwEsFactura() ? 'Factura' : 'Boleta', tipo_documento: dwEsFactura() ? 'RUC' : docTipoSel.value, documento: docNum.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase(), razon_social: docRazon.value } }) });
  }
  dr.querySelectorAll('input[name="dw-comprobante"]').forEach(function (r) { r.addEventListener('change', function () { dwModo(); clearTimeout(docTimer); docTimer = setTimeout(guardarDoc, 500); }); });
  docTipoSel.addEventListener('change', function () { docNum.value = ''; dwModo(); clearTimeout(docTimer); docTimer = setTimeout(guardarDoc, 500); });
  docNum.addEventListener('input', function () {
    var r = dwRegla();
    docNum.value = (r.num ? docNum.value.replace(/\D/g, '') : docNum.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase()).slice(0, r.max);
    docErr.hidden = dwValido() || docNum.value.trim() === '';
    clearTimeout(docTimer); docTimer = setTimeout(guardarDoc, 500);
  });
  docRazon.addEventListener('input', function () { clearTimeout(docTimer); docTimer = setTimeout(guardarDoc, 500); });
  dr.querySelector('[data-checkout]').addEventListener('click', function (e) {
    e.preventDefault();
    if (!dwValido()) { docErr.hidden = false; docNum.focus(); return; }
    // guardar los atributos antes de navegar, para que lleguen al pedido
    guardarDoc().then(function () { window.location.href = ROOT + 'checkout'; })
      .catch(function () { window.location.href = ROOT + 'checkout'; });
  });
  function fetchCart(open) { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); if (open) openCart(); return c; }); }
  function changeQty(key, qty) { fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); }); }
  function addToCart(body, name) {
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) { if (!res.ok) { showToast(res.d.description || 'No se pudo agregar'); return; } return fetchCart(true).then(function () { showToast((name || 'Producto') + ' agregado'); }); });
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); fetchCart(true); }); });
  fetchCart(false);

  /* ---------- interceptar formularios de producto ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form.matches('form[action$="/cart/add"], form[data-product-form]'))) return;
    e.preventDefault();
    var fd = new FormData(form);
    var body = { items: [{}] }; var props = {};
    fd.forEach(function (v, k) {
      if (k === 'id') body.items[0].id = v;
      else if (k === 'quantity') body.items[0].quantity = Number(v) || 1;
      else if (k.indexOf('properties[') === 0) { props[k.slice(11, -1)] = v; }
    });
    if (Object.keys(props).length) body.items[0].properties = props;
    var title = (form.querySelector('[data-product-title]') || {}).textContent;
    addToCart(body, title);
  });

  /* ---------- header + reveals ---------- */
  var hdr = document.querySelector('header');
  if (hdr) addEventListener('scroll', function () { hdr.classList.toggle('scrolled', scrollY > 8); }, { passive: true });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('inview'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    document.querySelectorAll('section, .sec-h, footer, .dec, .pdp').forEach(function (el) { io.observe(el); });
  }

  /* ---------- modal "personalización próximamente" (PDP) ---------- */
  var pmOpen = document.querySelector('[data-perso-modal-open]'),
    pm = document.querySelector('[data-perso-modal]'),
    pmOv = document.querySelector('[data-perso-modal-ov]');
  function openPm() { if (!pm) return; pm.hidden = false; setTimeout(function () { pm.classList.add('show'); if (pmOv) pmOv.classList.add('show'); }, 10); document.body.style.overflow = 'hidden'; var x = pm.querySelector('.x'); if (x) x.focus(); }
  function closePm() { if (!pm) return; pm.classList.remove('show'); if (pmOv) pmOv.classList.remove('show'); document.body.style.overflow = ''; setTimeout(function () { pm.hidden = true; }, 250); }
  if (pmOpen) pmOpen.addEventListener('click', openPm);
  if (pm) {
    var pmClose = pm.querySelector('[data-perso-modal-close]');
    if (pmClose) pmClose.addEventListener('click', closePm);
    if (pmOv) pmOv.addEventListener('click', closePm);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pm.hidden) closePm(); });
    // tras enviar el correo Shopify recarga con ?customer_posted=true:
    // si el mensaje de exito quedo dentro del modal, se reabre para mostrarlo
    if (location.search.indexOf('customer_posted=true') !== -1 && pm.querySelector('.wl__ok')) openPm();
  }

  /* ---------- dorsal oficial: glifos del club (dorsales-atlas.json) ----------
     El atlas se vectorizo desde 04-tipografia-dorsales/Dorsales y Numeros-U26.ai.
     Cada glifo trae 'w', 'h' y sus paths: cls "m" es el cuerpo (granate) y
     cls "i" son las lineas interiores, que se pintan encima en granate oscuro.
     Solo hay 0-9; el nombre sigue en Big Shoulders (el alfabeto del .ai aun no
     se extrajo). */
  var SVGNS = 'http://www.w3.org/2000/svg';
  var dorsalAtlas = null, dorsalAtlasReq = null;

  function loadDorsalAtlas(url) {
    if (dorsalAtlasReq) return dorsalAtlasReq;
    dorsalAtlasReq = fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { dorsalAtlas = j; return j; })
      .catch(function () { return null; });
    return dorsalAtlasReq;
  }

  /* Dibuja `value` (solo digitos) dentro de `host` como un <svg> escalable.
     Si el atlas no cargo, deja el texto tal cual para no romper el preview. */
  function renderDorsal(host, value) {
    var digits = String(value || '').replace(/[^0-9]/g, '').slice(0, 2);
    if (!dorsalAtlas || !digits) { host.textContent = digits; return; }

    var TRACK = 10, H = 207, x = 0, total = 0, i;
    for (i = 0; i < digits.length; i++) {
      if (!dorsalAtlas[digits[i]]) { host.textContent = digits; return; }
      total += dorsalAtlas[digits[i]].w + (i ? TRACK : 0);
    }

    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + total.toFixed(2) + ' ' + H);
    svg.setAttribute('class', 'dorsal-svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');

    for (i = 0; i < digits.length; i++) {
      var g = dorsalAtlas[digits[i]];
      var grp = document.createElementNS(SVGNS, 'g');
      grp.setAttribute('transform', 'translate(' + x.toFixed(2) + ',0)');
      g.paths.forEach(function (p) {
        var path = document.createElementNS(SVGNS, 'path');
        path.setAttribute('d', p.d);
        path.setAttribute('fill', p.cls === 'm' ? 'var(--granate, #A6192E)' : 'var(--granate-700, #7C2629)');
        grp.appendChild(path);
      });
      svg.appendChild(grp);
      x += g.w + TRACK;
    }

    host.textContent = '';
    host.appendChild(svg);
  }

  /* ---------- nombres vetados en el dorsal ---------- */
  /* El preview se comparte por WhatsApp: un dorsal "GALLINA" o "ALIANZA"
     circula como si lo hubiera hecho el club. Se compara sobre el texto
     normalizado (sin tildes, sin espacios, con leet resuelto y letras
     repetidas colapsadas) para que "A L 1 A N Z A" y "GALLLINA" caigan igual. */
  var LEET = { '0': 'O', '1': 'I', '3': 'E', '4': 'A', '5': 'S', '7': 'T', '8': 'B', '@': 'A', '$': 'S', '!': 'I', '|': 'I' };

  /* Rivales, apodos, insultos y todo lo que expone al club. Se buscan como
     parte del texto, así que "SOY ALIANZA" o "ALIANZA!!" también caen. */
  var VETADAS = [
    'ALIANZA', 'BLANQUIAZUL', 'GRONE', 'INTIMO', 'MATUTE', 'COMANDOSUR',
    'CRISTAL', 'BAJOPONTINO', 'EXTREMONORTE',
    'GALLINA', 'GALLINITA',
    'CONCHATUMADRE', 'CONCHATUMARE', 'REMILMIERDA', 'MIERDA', 'PUTAMADRE',
    'PUTA', 'PUTO', 'CAGON', 'CAGADA', 'PENDEJO', 'HUEVON', 'MARICON',
    'CULIAO', 'CULEAO', 'RECONCHA',
    'NAZI', 'HITLER', 'TERRUCO', 'SENDERO', 'ABIMAEL', 'COCAINA', 'MARIHUANA',
  ];
  /* Solo si el dorsal entero es eso: siglas cortas, y palabras que viven
     dentro de apellidos reales (VERGA está en VERGARA). */
  var VETADAS_EXACTAS = ['CTM', 'PTM', 'HDP', 'CSM', 'VERGA'];

  /* Nombres que ganan siempre: el plantel y las palabras que quedarían
     atrapadas por la regla de prefijo. CONCHA es el 17 del equipo y también
     el arranque de un insulto: si el dorsal es exactamente CONCHA, pasa. */
  var PERMITIDAS = [
    'CONCHA', 'CORZO', 'VALERA', 'POLO', 'REYNA', 'FLORES', 'LAPADULA', 'VARGAS',
    'CRISTIAN', 'CRISTINA', 'CELESTE', 'VERGARA', 'ALIAGA',
  ];

  function normalizaDorsal(texto) {
    return String(texto || '')
      .toUpperCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[0134578@$!|]/g, function (c) { return LEET[c] || c; })
      .replace(/[^A-Z]/g, '')
      .replace(/(.)\1+/g, '$1');
  }

  function creaFiltroDorsal(extras) {
    var lista = VETADAS.concat(extras || []).map(normalizaDorsal).filter(Boolean);
    var exactas = VETADAS_EXACTAS.map(normalizaDorsal).filter(Boolean);
    var permitidas = PERMITIDAS.map(normalizaDorsal).filter(Boolean);
    return function (texto) {
      var n = normalizaDorsal(texto);
      if (!n) return false;
      if (permitidas.indexOf(n) > -1) return false;
      if (exactas.indexOf(n) > -1) return true;
      for (var i = 0; i < lista.length; i++) {
        if (n.indexOf(lista[i]) > -1) return true;
        // El campo corta a 12 caracteres, así que "A L I A N Z A" llega como
        // "ALIANZ": un prefijo largo de una palabra vetada también cae.
        if (n.length >= 5 && lista[i].indexOf(n) === 0) return true;
      }
      return false;
    };
  }

  /* ---------- personalizador (dorsal) ---------- */
  var dorsal = document.getElementById('dorsal');
  if (dorsal) {
    var dn = document.getElementById('dname'), dm = document.getElementById('dnum'),
      inn = document.getElementById('inname'), inu = document.getElementById('innum'),
      sums = document.getElementById('sumstamp'), sump = document.getElementById('sumparche'),
      pprice = document.getElementById('parcheprice'), total = document.getElementById('total');
    var BASE = 29990, STAMP = 4900, parche = 2500;
    var aviso = document.getElementById('dorsalaviso');
    var esVetado = creaFiltroDorsal((dorsal.dataset.vetadas || '').split('\n'));
    var ultimoValido = (inn && inn.value ? inn.value.toUpperCase() : '') || 'LOLO';
    function pop() { dorsal.classList.remove('pop'); void dorsal.offsetWidth; dorsal.classList.add('pop'); }
    function upd() {
      var escrito = (inn.value || '').toUpperCase().slice(0, 12);
      var nu = (inu.value || '').replace(/[^0-9]/g, '').slice(0, 2) || '24';
      // El dorsal solo se pinta si pasa el filtro: se queda con el último
      // nombre válido en vez de estampar lo que no se va a poder vender.
      var bloqueado = esVetado(escrito);
      if (!bloqueado && escrito) ultimoValido = escrito;
      var nm = bloqueado ? ultimoValido : (escrito || 'HERNÁN');
      if (inn) inn.setAttribute('aria-invalid', bloqueado ? 'true' : 'false');
      if (aviso) aviso.hidden = !bloqueado;
      dn.textContent = nm;
      if (dm) renderDorsal(dm, nu);
      if (sums) sums.textContent = nm + ' · ' + nu;
      if (total) total.textContent = money(BASE + STAMP + parche);
      pop();
    }
    if (inn) inn.addEventListener('input', upd);
    if (inu) inu.addEventListener('input', upd);
    // el numero se pinta con los glifos oficiales apenas llega el atlas
    if (dorsal.dataset.dorsalAtlas) loadDorsalAtlas(dorsal.dataset.dorsalAtlas).then(upd);
    document.querySelectorAll('.chip[data-parche]').forEach(function (ch) {
      ch.addEventListener('click', function () {
        document.querySelectorAll('.chip[data-parche]').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        ch.setAttribute('aria-pressed', 'true');
        parche = Math.round(parseFloat(ch.dataset.parche) * 100);
        if (sump) sump.textContent = ch.textContent.split('·')[0].trim();
        if (pprice) pprice.textContent = money(parche);
        upd();
      });
    });
    upd();
  }

  /* ---------- PDP: galería, tallas, cantidad ---------- */
  var gal = document.querySelector('.gal');
  if (gal) {
    var main = gal.querySelector('.main img');
    var thumbs = [].slice.call(gal.querySelectorAll('.thumbs button'));
    var counter = gal.querySelector('[data-gallery-count]');
    var current = 0;

    function showThumb(idx) {
      if (!thumbs.length) return;
      current = (idx + thumbs.length) % thumbs.length;
      var b = thumbs[current];
      thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      b.setAttribute('aria-current', 'true');
      b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (main && b.dataset.full) {
        main.classList.add('fade');
        setTimeout(function () {
          main.src = b.dataset.full;
          if (b.dataset.alt) main.alt = b.dataset.alt;
          main.classList.remove('fade');
        }, 200);
      }
      if (counter) counter.textContent = (current + 1) + '/' + thumbs.length;
    }

    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { showThumb(i); }); });
    var prev = gal.querySelector('[data-gallery-prev]'), next = gal.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { showThumb(current - 1); });
    if (next) next.addEventListener('click', function () { showThumb(current + 1); });
  }

  /* ---------- PDP: personalizacion (nombre, dorsal y parches) ----------
     Los campos son line item properties nativos: viajan solos en /cart/add.js.
     Van `disabled` mientras el bloque esta cerrado para no mandar props vacios.
     El recargo que se muestra es una ESTIMACION; el cobro real lo aplica la
     Cart Transform Function (por eso `personalization_enabled` va apagado
     hasta que este desplegada). */
  var perso = document.querySelector('[data-personalizer]');
  if (perso) {
    var pToggle = perso.querySelector('[data-personalizer-toggle]'),
      pFields = perso.querySelector('[data-personalizer-fields]'),
      pName = perso.querySelector('[data-personalizer-name]'),
      pNum = perso.querySelector('[data-personalizer-number]'),
      pPatchesVal = perso.querySelector('[data-personalizer-patches-value]'),
      pSurcharge = perso.querySelector('[data-personalizer-surcharge]'),
      pEstimate = perso.querySelector('[data-personalizer-estimate]'),
      pPreview = perso.querySelector('[data-personalizer-preview]'),
      pPrevName = perso.querySelector('[data-personalizer-preview-name]'),
      pPrevNum = perso.querySelector('[data-personalizer-preview-num]'),
      pPatches = [].slice.call(perso.querySelectorAll('[data-personalizer-patch]')),
      galPatch = document.querySelector('[data-gallery-patch]'),
      galPatchImg = document.querySelector('[data-gallery-patch-img]');

    var rateLetter = parseFloat(perso.dataset.rateLetter) || 0,
      rateNumber = parseFloat(perso.dataset.rateNumber) || 0;

    if (pPrevNum && pPrevNum.dataset.dorsalAtlas) {
      loadDorsalAtlas(pPrevNum.dataset.dorsalAtlas).then(function () { updPerso(); });
    }

    function updPerso() {
      var on = pToggle && pToggle.checked;
      var name = (pName && pName.value || '').toUpperCase().replace(/[^A-ZÑÁÉÍÓÚ .'-]/g, '');
      var num = (pNum && pNum.value || '').replace(/[^0-9]/g, '');
      if (pName && pName.value !== name) pName.value = name;
      if (pNum && pNum.value !== num) pNum.value = num;

      var chosen = pPatches.filter(function (c) { return c.checked; });
      var patchTotal = chosen.reduce(function (a, c) { return a + (parseFloat(c.dataset.price) || 0); }, 0);
      var total = (name ? name.replace(/\s/g, '').length * rateLetter : 0) + (num ? rateNumber : 0) + patchTotal;

      // los inputs deshabilitados no se envian: es como se evita mandar props vacios
      [pName, pNum, pPatchesVal, pSurcharge].forEach(function (el) { if (el) el.disabled = !on; });
      if (pFields) pFields.hidden = !on;
      if (pPatchesVal) pPatchesVal.value = chosen.map(function (c) { return c.dataset.name; }).join(' + ');
      if (pSurcharge) pSurcharge.value = total.toFixed(2);

      if (pPreview) pPreview.hidden = !(on && (name || num));
      if (pPrevName) pPrevName.textContent = name;
      if (pPrevNum) renderDorsal(pPrevNum, num);

      // recuadro del parche sobre la foto principal (patron Real Madrid)
      var withArt = chosen.filter(function (c) { return c.dataset.img; })[0];
      if (galPatch) {
        if (on && withArt && galPatchImg) {
          galPatchImg.src = withArt.dataset.img;
          galPatchImg.alt = withArt.dataset.name;
          galPatch.hidden = false;
        } else {
          galPatch.hidden = true;
        }
      }

      if (pEstimate) {
        pEstimate.textContent = !on ? ''
          : total > 0 ? 'Personalización: + ' + money(Math.round(total * 100))
            : 'Escribe tu nombre, tu dorsal o suma un parche.';
      }
    }

    if (pToggle) pToggle.addEventListener('change', updPerso);
    if (pName) pName.addEventListener('input', updPerso);
    if (pNum) pNum.addEventListener('input', updPerso);
    pPatches.forEach(function (c) { c.addEventListener('change', updPerso); });
    updPerso();
  }
  var pdpForm = document.getElementById('pdp-form');
  if (pdpForm) {
    var variants = [];
    var vnode = document.querySelector('[data-product-json]');
    if (vnode) { try { variants = JSON.parse(vnode.textContent).variants || []; } catch (e) {} }
    var idInput = pdpForm.querySelector('[name="id"]');
    document.querySelectorAll('.sizes button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        document.querySelectorAll('.sizes button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        var size = b.textContent.trim();
        var mv = variants.filter(function (v) { return (v.options || []).indexOf(size) !== -1 || v.title === size; })[0];
        if (mv && idInput) idInput.value = mv.id;
      });
    });
    var qn = 1, qEl = document.querySelector('.qty span'), qInput = pdpForm.querySelector('[name="quantity"]');
    document.querySelectorAll('.qty button').forEach(function (b) {
      b.addEventListener('click', function () { qn = Math.max(1, qn + (b.dataset.q === '+' ? 1 : -1)); if (qEl) qEl.textContent = qn; if (qInput) qInput.value = qn; });
    });
  }
})();

